export default __webpack_public_path__ + "static/media/why5.3a8914dc.png";